export type PlanCompositionRow = {
  id: string | number
  serviceName: string
  toothNumber: string | number | null
  quantity: number
  unitPrice: number | null
  totalPrice: number | null
  isExecuted?: boolean
}

export function mapPublicPlanServicesToCompositionRows(
  services: Array<{
    id: string | number
    service_name: string
    tooth_number?: string | number | null
    quantity?: number | null
    unit_price?: number | null
    total_price?: number | null
    is_executed?: boolean
    is_executed_flag?: boolean
    is_completed?: boolean
  }>,
): PlanCompositionRow[] {
  return services.map((svc) => ({
    id: svc.id,
    serviceName: svc.service_name,
    toothNumber: svc.tooth_number ?? null,
    quantity: svc.quantity ?? 1,
    unitPrice: svc.unit_price ?? null,
    totalPrice: svc.total_price ?? svc.unit_price ?? null,
    isExecuted: Boolean(svc.is_executed || svc.is_executed_flag || svc.is_completed),
  }))
}
